import React, { useState, useEffect } from "react";
import {
  arraySortAscending,
  arraySortDescending,
  arraySortPriceAscending,
  arraySortPriceDescending,
  numberWithCommas,
  roundOffTwoDecimal,
} from "../../util";
import axios from "axios";
import "./Homepage.css";
import { useDispatch, useSelector } from "react-redux";
import getLoaderActions from "../../actions/LoaderActions";
import getMode from "../../actions/modeActions";

export default function Homepage() {
  const [highlow, sethighlow] = useState("low");
  const [pricehighlow, setpricehighlow] = useState("low");
  const [highlowArray, sethighlowArray] = useState([]);
  const [pricehighlowArray, setpricehighlowArray] = useState([]);
  const [coinData, setcoinData] = useState([]);
  const [bestWorst, setbestWorst] = useState([]);
  //const [mode, setmode] = useState('')

  const dispatch = useDispatch();
  let loader = useSelector((state) => state.Loader.state);
  const mode = useSelector((state) => state.mode.payload);
  //-----------------------------------API Call---------------------------------------------------//

  useEffect(() => {
    //localStorage.setItem('mode','dark')

    function getAlerts() {
      axios
        .get(
          "https://api.coingecko.com/api/v3/coins/markets?vs_currency=inr&order=market_cap_desc&per_page=100&page=1&sparkline=false"
        )
        .then((response) => {
          dispatch(getLoaderActions("true"));
          if (localStorage.getItem("mode")) {
            dispatch(getMode(localStorage.getItem("mode")));
          }
          setcoinData(response.data);
          setbestWorst(response.data);
        });
    }
    if (loader === "false") {
      setTimeout(() => {
        getAlerts();
      }, 2000);
    } else {
      getAlerts();
    }
    const interval = setInterval(() => getAlerts(), 10000);
    return () => {
      clearInterval(interval);
    };
       // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //-------------------Crypto Price Ascending Descending-----------------------------//
  const getPriceHighLowFunction = (e) => {
    setpricehighlow(e);
    setpricehighlowArray(coinData);
    getPriceHighLow(pricehighlow);
  };

  const getHighLowFunction = (e) => {
    sethighlow(e);
    sethighlowArray(coinData);
    getHighLow(highlow);
  };

  const getPriceHighLow = (e) => {
    switch (e) {
      case "high":
        return arraySortPriceDescending(pricehighlowArray);
      case "low":
        return arraySortPriceAscending(pricehighlowArray);
      default:
        break;
    }
  };

  const getHighLow = (x) => {
    switch (x) {
      case "high":
        arraySortDescending(highlowArray);
        break;
      case "low":
        arraySortAscending(highlowArray);
        break;
      default:
        break;
    }
  };

  //--------------------------------------------Crypto Market Table----------------------------//
  const coinDataRows = coinData.filter((item) =>  item.current_price && item.low_24h && item.high_24h ).map((item,index)=>{
    return (
      <tr key={index}>
        <td>
          <img
            style={{ height: "40px" }}
            src={item.image}
            alt="Coin Icon"
          ></img>
        </td>
        <td>
          <h4>{item.name} </h4>
          <h5>{item.symbol}</h5>
        </td>
        <td>{numberWithCommas(item.current_price)}</td>
        <td>{numberWithCommas(item.low_24h)}</td>
        <td>{numberWithCommas(item.high_24h)}</td>
        {item.price_change_percentage_24h < 0 ? (
          <td style={{ color: "red" }}>
            -{roundOffTwoDecimal(item.price_change_percentage_24h)}%
          </td>
        ) : (
          <td style={{ color: "green" }}>
            +{roundOffTwoDecimal(item.price_change_percentage_24h)}%
          </td>
        )}
      </tr>
    );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  });

  //-------------------------------------Crypto Best/Worst Cards------------------------------------------//

  const bestIncreaseArray = bestWorst.reduce(
    (acc, shot) =>
      (acc =
        acc.price_change_percentage_24h > shot.price_change_percentage_24h
          ? acc
          : shot),
    0
  );
  const bestCoin = [bestIncreaseArray].map((item, index) => {
    return (
      <div key={index}>
        <img src={item.image} alt="Best Coin Icon"></img>
        <br />
        <b>{item.name}</b>
        <br />
        <p>₹{item.price_change_24h ? numberWithCommas(item.current_price):0}</p>
        <p style={{ color: "green" }}>
          {item.price_change_percentage_24h
            ? roundOffTwoDecimal(item.price_change_percentage_24h)
            : 0}
          % (+₹
          {item.price_change_24h > 1
            ? roundOffTwoDecimal(item.price_change_24h)
            : item.price_change_24h}
          )
        </p>
      </div>
    );
  });

  const worstIncreaseArray = bestWorst.reduce(
    (acc, shot) =>
      acc.price_change_percentage_24h < shot.price_change_percentage_24h
        ? acc
        : shot,
    0
  );
  const worstCoin = [worstIncreaseArray].map((item, index) => {
    return (
      <div key={index}>
        <img src={item.image} alt="Worst Coin icon"></img>
        <br />
        <b>{item.name}</b>
        <br />
        <p>₹{item.price_change_24h ? numberWithCommas(item.current_price):0}</p>
        <p style={{ color: "red" }}>
          {item.price_change_percentage_24h
            ? roundOffTwoDecimal(item.price_change_percentage_24h)
            : 0}
          % (-₹
          {item.price_change_24h < 1
            ? roundOffTwoDecimal(item.price_change_24h)
            : item.price_change_24h}
          )
        </p>
      </div>
    );
  });

  const highestMarketCapArray = bestWorst.reduce(
    (acc, shot) => (acc = acc.market_cap > shot.market_cap ? acc : shot),
    0
  );
  const highestMarketCap = [highestMarketCapArray].map((item, index) => {
    return (
      <div key={index}>
        <img src={item.image} alt="Highest Market Cap Icon"></img>
        <br />
        <b>{item.name}</b>
        <br />
        <p>
          ₹
          {item.market_cap
            ? numberWithCommas(item.market_cap)
            : item.market_cap}
        </p>
      </div>
    );
  });

  const lowestMarketCapArray = bestWorst.reduce(
    (acc, shot) => (acc = acc.market_cap < shot.market_cap ? acc : shot),
    0
  );
  const lowestMarketCap = [lowestMarketCapArray].map((item, index) => {
    return (
      <div key={index}>
        <img src={item.image} alt="Lowest Market Cap Item"></img>
        <br />
        <b>{item.name}</b>
        <br />
        <p>
          ₹
          {item.market_cap
            ? numberWithCommas(item.market_cap)
            : item.market_cap}
        </p>
      </div>
    );
  });

  const highpricedArray = bestWorst.reduce(
    (acc, shot) => (acc = acc.current_price > shot.current_price ? acc : shot),
    0
  );
  const highpriced = [highpricedArray].map((item, index) => {
    return (
      <div key={index}>
        <img src={item.image} alt="Highest Priced Icon"></img>
        <br />
        <b>{item.name}</b>
        <br />
        <p>
          ₹
          {item.current_price
            ? numberWithCommas(item.current_price)
            : item.current_price}
        </p>
      </div>
    );
  });

  const lowpricedArray = bestWorst.reduce(
    (acc, shot) => (acc = acc.current_price < shot.current_price ? acc : shot),
    0
  );
  const lowpriced = [lowpricedArray].map((item, index) => {
    return (
      <div key={index}>
        <img src={item.image} alt="Lowest Priced Icon"></img>
        <br />
        <b>{item.name}</b>
        <br />
        <p>
          ₹
          {item.current_price
            ? numberWithCommas(item.current_price)
            : item.current_price}
        </p>
      </div>
    );
  });

  //----------------------------------------------------------------------------------------------------------//

  return (
    <>
      {loader === "false" ? (
        ""
      ) : (
        <div className={mode === "dark" ? "darkhomepage" : "homepage"}>
          <div className={mode === "dark" ? "darkcryptoStats" : "cryptoStats"}>
            <table className={mode === "dark" ? "darktable" : ""}>
              <thead>
                <tr>
                  <th>Symbol</th>
                  <th>Name</th>
                  <th
                    onClick={
                      pricehighlow === "low"
                        ? () => getPriceHighLowFunction("high")
                        : () => getPriceHighLowFunction("low")
                    }
                  >
                    Price (₹)<i className="sort icon"></i>
                  </th>
                  <th>24h Low (₹)</th>
                  <th>24h High (₹)</th>
                  <th
                    onClick={
                      highlow === "low"
                        ? () => getHighLowFunction("high")
                        : () => getHighLowFunction("low")
                    }
                  >
                    24hr Change(%) <i className="sort icon"></i>
                  </th>
                </tr>
              </thead>
              <tbody>{coinDataRows}</tbody>
            </table>
          </div>

          <div
            className={
              mode === "dark" ? "darkbestworstCards" : "bestworstCards"
            }
          >
            <div
              className={mode === "dark" ? "darkbestIncrease" : "bestIncrease"}
              id="darkbestIncrease"
            >
              <div>
                <div>
                  <h3>Best Performer(24h)</h3>
                  {bestCoin}
                </div>
                <div>
                  <h3>Worst Performer(24h)</h3>
                  {worstCoin}
                </div>
              </div>
              <div>
                <div>
                  <h3>Highest priced</h3>
                  {highpriced}
                </div>

                <div>
                  <h3>Lowest Priced</h3>
                  {lowpriced}
                </div>
              </div>
              <div>
                <div>
                  <h3>Highest Market Cap</h3>
                  {highestMarketCap}
                </div>
                <div>
                  <h3>Lowest Market Cap</h3>
                  {lowestMarketCap}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
